import { render, staticRenderFns } from "./ExpedientePersonal.vue?vue&type=template&id=35ad473d&scoped=true"
import script from "./ExpedientePersonal.vue?vue&type=script&lang=js"
export * from "./ExpedientePersonal.vue?vue&type=script&lang=js"
import style0 from "./ExpedientePersonal.vue?vue&type=style&index=0&id=35ad473d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad473d",
  null
  
)

export default component.exports